export const WRITING_ISSUES_NO_PREFIX_FILTERS = [
    "groupBy",
    "timeZone",
    "webSearchSyntax",
    "interactionType",
    "issue",
    "writingIssueType",
] as const;
